import { useState } from "react";
import { channels } from "@/mocks/gossip";

export default function Channels() {
  const [activeIdx, setActiveIdx] = useState(0);
  const active = channels[activeIdx];

  return (
    <section id="channels" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-secondary-600">
              <i className="ri-store-2-line"></i> 瓜田分类盘点
            </p>
            <h2 className="serif-title mt-2 text-3xl font-black text-foreground-950 md:text-4xl">
              想蹲哪块，直接切到哪块
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-500">
            综艺、影视、音乐、红毯、电竞、花边六大频道，点击上方频道即可切换当天内容。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {channels.map((c, i) => (
            <button
              key={c.name}
              onClick={() => setActiveIdx(i)}
              className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
                i === activeIdx
                  ? "bg-secondary-600 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              <i className={`${c.icon} ${i === activeIdx ? "" : "text-secondary-600"}`}></i>
              {c.name}
            </button>
          ))}
        </div>

        <div key={active.name} className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="h-full overflow-hidden rounded-2xl border border-background-200">
              <img
                src={active.image}
                alt={`${active.name}吃瓜分类内容配图`}
                title={`吃瓜今日-${active.name}`}
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
          <div className="flex flex-col gap-4 lg:col-span-3">
            {active.items.map((it, idx) => (
              <article
                key={it.title}
                className="flex-1 rounded-2xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-secondary-300"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className="ri-file-list-3-line text-sm"></i>
                  </span>
                  <span className="text-xs font-medium text-foreground-400">今日精选 · 第 {idx + 1} 条</span>
                </div>
                <h3 className="serif-title mt-3 text-lg font-bold leading-snug text-foreground-900">
                  {it.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{it.desc}</p>
                <div className="mt-4 flex items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-500 border border-background-200">
                    <i className="ri-chat-1-line"></i> 456 讨论
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-500 border border-background-200">
                    <i className="ri-fire-line text-secondary-500"></i> 12.8 万热度
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}